import { QueryObserverResult, useMutation, UseMutationResult, useQuery } from 'react-query';
import { CronJobResponse, CronJobRunResponse, getCronJobs, runCronJob } from 'api/cron-jobs';
import { AxiosError } from 'axios';

import { HttpException } from '../common/models/httpException';

export const CK_CRON_JOBS = 'cron-jobs';

export const useCronJobsList = (): QueryObserverResult<CronJobResponse[], AxiosError<HttpException>> => {
  return useQuery([CK_CRON_JOBS], () => getCronJobs());
};

export const useRunCronJob = (): UseMutationResult<CronJobRunResponse, AxiosError<HttpException>, string> => {
  return useMutation((name: string) => runCronJob(name));
};
